<app-dialog-container [showKeyboardButton]="false" [showHelpButton]="false">

  <!-- HEADER -->
  <div class="dialog-header" fxLayout="row" fxLayoutAlign="space-between center">
    <h1 mat-dialog-title>
      <mat-icon>description</mat-icon>
      {{ dialogTitle }}
    </h1>
    <button
      type="button"
      mat-icon-button
      class="header-close-btn"
      (click)="onCancel()"
      aria-label="Fechar modal">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="creation-content">

    <form [formGroup]="form">
      <!-- SECAO: CONFIGURACAO DA VARIACAO -->
      <div class="section-card">
        <div class="section-title">
          <mat-icon>tune</mat-icon>
          <span>Configuração do Plano</span>
        </div>

        <div class="subsection-title">Dados e Regras do Plano</div>
        <div
          fxLayout="row wrap"
          fxLayoutGap="16px"
          class="form-row">
          <!-- Tipo de plano fixo NORMAL no core (sem REVENDA); o campo de
               produto/solucao do topo so existe para REVENDA no nexus. -->

          <mat-form-field fxFlex="calc(18% - 16px)" fxFlex.lt-md="100" appearance="outline">
            <mat-label>NOME DO PLANO</mat-label>
            <input matInput formControlName="name" placeholder="Ex: START - ONE - CM" [readonly]="isShowMode || isPlanRulesLocked" />
          </mat-form-field>

          <mat-form-field fxFlex="calc(8% - 16px)" fxFlex.lt-md="calc(50% - 16px)" appearance="outline">
            <mat-label>QT ACESSOS</mat-label>
            <input matInput type="number" min="1" formControlName="accessQuantity" [readonly]="isShowMode || isPlanRulesLocked" />
          </mat-form-field>

          <mat-form-field fxFlex="calc(10% - 16px)" fxFlex.lt-md="calc(50% - 16px)" appearance="outline">
            <mat-label>TIPO ACESSO</mat-label>
            <mat-select formControlName="accessType" placeholder="Selecione" [disabled]="isShowMode || isPlanRulesLocked">
              <mat-option *ngFor="let a of accessTypeOptions" [value]="a">{{ a }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field fxFlex="calc(10% - 16px)" fxFlex.lt-md="calc(50% - 16px)" appearance="outline">
            <mat-label>VENCIMENTO</mat-label>
            <input matInput formControlName="dueDate" [readonly]="isShowMode" />
          </mat-form-field>

          <mat-form-field fxFlex="calc(8% - 16px)" fxFlex.lt-md="calc(50% - 16px)" appearance="outline">
            <mat-label>HTML?</mat-label>
            <mat-select formControlName="htmlEnabled" [disabled]="isShowMode || isPlanRulesLocked">
              <mat-option *ngFor="let option of yesNoOptions" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <div
          fxLayout="row wrap"
          fxLayoutGap="16px"
          class="form-row">
          <mat-form-field fxFlex="calc(18% - 16px)" fxFlex.lt-md="100" appearance="outline">
            <mat-label>PARCEIROS</mat-label>
            <mat-select
              [disabled]="isShowMode || isPlanRulesLocked"
              [value]="partnerSelectionMode"
              (selectionChange)="onPartnerSelectionModeChange($event.value)">
              <mat-option value="ALL">Todos</mat-option>
              <mat-option value="SELECT" (click)="onSelectPartnersOptionClick()">Selecionar</mat-option>
            </mat-select>
            <mat-hint *ngIf="partnerSelectionMode === 'SELECT' && selectedPartners.length > 0">
              {{ selectedPartners.length }} parceiro(s) selecionado(s)
            </mat-hint>
          </mat-form-field>

          <mat-form-field fxFlex="calc(8% - 16px)" fxFlex.lt-md="calc(33.333% - 16px)" appearance="outline">
            <mat-label>COMISSÃO?</mat-label>
            <mat-select formControlName="payCommission" [disabled]="isShowMode || isPlanRulesLocked">
              <mat-option [value]="true">Sim</mat-option>
              <mat-option [value]="false">Não</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field fxFlex="calc(8% - 16px)" fxFlex.lt-md="calc(33.333% - 16px)" appearance="outline">
            <mat-label>DIAS CORRIDOS?</mat-label>
            <mat-select formControlName="isDaysCount" [disabled]="isShowMode || isPlanRulesLocked">
              <mat-option [value]="true">Sim</mat-option>
              <mat-option [value]="false">Não</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field fxFlex="calc(8% - 16px)" fxFlex.lt-md="calc(33.333% - 16px)" appearance="outline">
            <mat-label>ADESÃO?</mat-label>
            <mat-select formControlName="hasAdhesion" [disabled]="isShowMode || isPlanRulesLocked">
              <mat-option [value]="true">Sim</mat-option>
              <mat-option [value]="false">Não</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- SECAO: VARIACOES DO PLANO -->
      <div class="section-card variations-section">
        <div class="section-title">
          <mat-icon>list_alt</mat-icon>
          <span>VARIAÇÕES DO PLANO</span>
        </div>

        <div
          fxLayout="row wrap"
          fxLayoutGap="16px"
          class="form-row row-with-save">
        <mat-form-field *ngIf="!isResalePlan" fxFlex="calc(14% - 16px)" fxFlex.lt-md="100" appearance="outline">
          <mat-label>TIPO PRODUTO/SOLUÇÃO</mat-label>
          <mat-select formControlName="type" placeholder="Selecione">
            <mat-option *ngFor="let t of systemTypeOptions" [value]="t">{{ t }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="!isResalePlan" fxFlex="calc(16% - 16px)" fxFlex.lt-md="100" appearance="outline">
          <mat-label>PRODUTO/SOLUÇÃO</mat-label>
          <mat-select formControlName="system" placeholder="Selecione">
            <mat-option *ngFor="let s of systems" [value]="s.id">{{ s.name }}</mat-option>
          </mat-select>
          <mat-hint *ngIf="!form.value.type">Selecione um tipo primeiro</mat-hint>
        </mat-form-field>

        <mat-form-field fxFlex="calc(22% - 16px)" fxFlex.lt-md="100" appearance="outline">
          <mat-label>MÓDULOS</mat-label>
          <mat-select
            placeholder="Selecione módulos"
            [disabled]="isShowMode"
            [value]="selectedModuleId"
            (openedChange)="onModulesOpened($event)"
            (selectionChange)="onModuleSelectionChange($event.value)">
            <mat-option
              *ngFor="let m of availableModulesForSelection"
              [value]="m.id">
              {{ m.name }}
            </mat-option>
          </mat-select>
          <mat-hint>{{ selectedModules.length > 0 ? '1 selecionado' : 'Nenhum selecionado' }}</mat-hint>
        </mat-form-field>

        <ng-container *ngIf="form.get('hasAdhesion')?.value">
          <mat-form-field
            fxFlex="calc(10% - 16px)"
            fxFlex.lt-md="calc(50% - 16px)"
            appearance="outline"
            class="money-field">
            <mat-label>VALOR ADESÃO</mat-label>
            <input
              matInput
              currencyMask
              inputmode="decimal"
              formControlName="adhesionValue" />
          </mat-form-field>
        </ng-container>

        <mat-form-field *ngIf="!isPartnerUser" fxFlex="calc(10% - 16px)" fxFlex.lt-md="calc(50% - 16px)" appearance="outline" class="money-field">
          <mat-label>CUSTO</mat-label>
          <input
            matInput
            currencyMask
            inputmode="decimal"
            formControlName="cost" />
        </mat-form-field>

        <mat-form-field fxFlex="calc(12% - 16px)" fxFlex.lt-md="calc(50% - 16px)" appearance="outline" class="money-field">
          <mat-label>VALOR ACESSO</mat-label>
          <input
            matInput
            currencyMask
            inputmode="decimal"
            formControlName="valuePerAccess" />
        </mat-form-field>

        <div fxFlex="calc(12% - 16px)" fxFlex.lt-md="100" class="save-variation-col" fxLayout="row" fxLayoutAlign="end center">
          <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="!canSaveVariation"
            *ngIf="!isShowMode"
            (click)="saveVariation()">
            <mat-icon>{{ editingVariationIndex !== null ? 'save' : 'add_circle' }}</mat-icon>
            {{ editingVariationIndex !== null ? 'SALVAR' : 'ADICIONAR' }}
          </button>
        </div>
        </div>

        <div class="variations-title-divider" *ngIf="variations.length > 0"></div>

        <div class="variations-table-wrapper" *ngIf="variations.length > 0">
          <table mat-table [dataSource]="variationsDataSource" class="variations-table">

          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef>CODIGO</th>
            <td mat-cell *matCellDef="let row">{{ row.codigo }}</td>
          </ng-container>

          <ng-container matColumnDef="tipoSolucao">
            <th mat-header-cell *matHeaderCellDef>TIPO PRODUTO/SOLUÇÃO</th>
            <td mat-cell *matCellDef="let row">{{ row.tipoSolucao }}</td>
          </ng-container>

          <ng-container matColumnDef="solucao">
            <th mat-header-cell *matHeaderCellDef>PRODUTO/SOLUÇÃO</th>
            <td mat-cell *matCellDef="let row">{{ row.solucao }}</td>
          </ng-container>

          <ng-container matColumnDef="valorMensalidade">
            <th mat-header-cell *matHeaderCellDef>VALOR DE ACESSO R$</th>
            <td mat-cell *matCellDef="let row">{{ row.valorMensalidade | currency:'BRL':'symbol':'1.2-2' }}</td>
          </ng-container>

          <ng-container matColumnDef="custo">
            <th mat-header-cell *matHeaderCellDef>CUSTO R$</th>
            <td mat-cell *matCellDef="let row">{{ (row.custo ?? row.cost) | currency:'BRL':'symbol':'1.2-2' }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>STATUS</th>
            <td mat-cell *matCellDef="let row">
              <span
                class="status-badge"
                [ngClass]="isVariationActive(row.status) ? 'active' : 'inactive'">
                {{ row.status }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef>AÇÕES</th>
            <td mat-cell *matCellDef="let row; let i = index">
              <button
                mat-icon-button
                matTooltip="Info: Acesso {{ row.qtAcesso }} | Tipo {{ row.acesso }} | Vencimento {{ row.vencimento }}">
                <mat-icon>info_outline</mat-icon>
              </button>
              <button mat-icon-button (click)="editVariation(i)" matTooltip="Editar" *ngIf="!isShowMode">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="removeVariation(i)" matTooltip="Excluir" *ngIf="!isShowMode">
                <mat-icon>delete</mat-icon>
              </button>
              <button
                mat-icon-button
                [matTooltip]="isVariationActive(row.status) ? 'Inativar' : 'Ativar'"
                (click)="toggleVariationStatus(i)"
                *ngIf="!isShowMode">
                <mat-icon [ngClass]="isVariationActive(row.status) ? 'flag-active' : 'flag-inactive'">
                  {{ isVariationActive(row.status) ? 'toggle_on' : 'toggle_off' }}
                </mat-icon>
              </button>
            </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="variationColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: variationColumns;"></tr>
          </table>
        </div>
      </div>
    </form>

    <!-- SECAO: ABAS -->
    <div class="section-card">
      <mat-tab-group class="plan-tabs" animationDuration="200ms">

        <!-- Aba: Descrição -->
          <mat-tab label="Descrição">
          <div class="tab-content">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Descrição do Plano</mat-label>
              <textarea
                matInput
                [formControl]="descriptionControl"
                rows="5"
                placeholder="Descrição manual do plano, texto para entendimento do que se trata o plano">
              </textarea>
            </mat-form-field>
          </div>
        </mat-tab>

        <!-- Aba: Módulos -->
        <mat-tab label="Módulos">
          <div class="tab-content">
            <div class="item-list module">
              <div class="item-chip module" *ngFor="let module of variationModules">
                <span class="dot"></span>
                <span class="text">{{ module?.name || module }}</span>
              </div>

              <div class="empty-tab" *ngIf="variationModules.length === 0">
                <mat-icon>view_list</mat-icon>
                <p>Nenhum módulo selecionado na variação.</p>
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- Aba: Incluído -->
          <mat-tab label="Incluído">
          <div class="tab-content">
            <div class="item-editor include">
              <mat-form-field appearance="outline" class="item-input">
                <mat-label>Item incluído</mat-label>
                <input
                  matInput
                  [readonly]="isShowMode"
                  [value]="includedItemText"
                  (input)="includedItemText = $any($event.target).value"
                  (keyup.enter)="addIncludedItem()"
                  placeholder="Digite o item..." />
              </mat-form-field>
              <button type="button" mat-raised-button class="include-add-btn" (click)="addIncludedItem()" *ngIf="!isShowMode">
                <mat-icon>add</mat-icon>
                Adicionar
              </button>
            </div>

            <div class="item-list include">
              <div class="item-chip include" *ngFor="let item of includedItems; let i = index">
                <span class="dot"></span>
                <span class="text">{{ item }}</span>
                <button type="button" mat-icon-button (click)="removeIncludedItem(i)" matTooltip="Remover" *ngIf="!isShowMode">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- Aba: Não Incluído -->
          <mat-tab label="Não Incluído">
          <div class="tab-content">
            <div class="item-editor exclude">
              <mat-form-field appearance="outline" class="item-input">
                <mat-label>Item não incluído</mat-label>
                <input
                  matInput
                  [readonly]="isShowMode"
                  [value]="excludedItemText"
                  (input)="excludedItemText = $any($event.target).value"
                  (keyup.enter)="addExcludedItem()"
                  placeholder="Digite o item..." />
              </mat-form-field>
              <button type="button" mat-raised-button color="warn" (click)="addExcludedItem()" *ngIf="!isShowMode">
                <mat-icon>add</mat-icon>
                Adicionar
              </button>
            </div>

            <div class="item-list exclude">
              <div class="item-chip exclude" *ngFor="let item of excludedItems; let i = index">
                <span class="dot"></span>
                <span class="text">{{ item }}</span>
                <button type="button" mat-icon-button (click)="removeExcludedItem(i)" matTooltip="Remover" *ngIf="!isShowMode">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </mat-tab>


      </mat-tab-group>
    </div>

  </div>

  <!-- FOOTER -->
  <div mat-dialog-actions class="dialog-footer" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="footer-left" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start center">
      <div class="total-cost-card" *ngIf="!isPartnerUser">
        <span class="total-label">TOTAL CUSTO</span>
        <span class="total-value">{{ totalCostValue | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="total-plan-card">
        <span class="total-label">TOTAL PLANO</span>
        <span class="total-value">{{ totalPlanValue | currency:'BRL':'symbol':'1.2-2' }}</span>
      </div>
      <div class="footer-meta-card" fxLayout="row">
        <div class="meta-item">
          <span class="meta-label">DATA CADASTRO</span>
          <span class="meta-value">{{ createdAtDisplay | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="meta-item">
          <span class="meta-label">ÚLTIMA ALTERAÇÃO</span>
          <span class="meta-value">
            {{ lastUpdatedDisplay ? (lastUpdatedDisplay | date:'dd/MM/yyyy HH:mm') : '--/--/---- --:--' }}
          </span>
        </div>
        <div class="meta-item">
          <span class="meta-label">ALTERADO POR</span>
          <span class="meta-value meta-link">{{ changedByDisplay }}</span>
        </div>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="12px">
      <button mat-stroked-button (click)="onCancel()">{{ isShowMode ? 'FECHAR' : 'CANCELAR' }}</button>
      <button
        *ngIf="!isShowMode"
        type="button"
        mat-raised-button
        color="primary"
        [disabled]="!canSavePlan"
        (click)="onSave()">
        SALVAR
      </button>
    </div>
  </div>

</app-dialog-container>











